/**
 * Treats Quill/HTML content as empty when it has no meaningful text.
 * Quill empty content is typically non-empty HTML like <p><br></p>.
 */
export const isQuillContentEmpty = (html: string): boolean => {
  if (!html || typeof html !== "string") return true;
  const div = document.createElement("div");
  div.innerHTML = html;
  const text = (div.textContent || div.innerText || "").trim();

  // If there is any textual content, it's not empty.
  if (text.length > 0) {
    return false;
  }

  // Treat common non-text Quill elements as non-empty (e.g., image-only content).
  const nonTextContent = div.querySelector("img,video,iframe,svg,embed");
  return !nonTextContent;
};
